import { match } from 'ts-pattern';
export const migrateToV4 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'KickPlateBoltHoles'
        }, ({ count, ...kickPlateFixingHoles })=>({
                ...kickPlateFixingHoles,
                horizontalCount: count,
                verticalCount: 0
            })).with({
            type: 'KickPlateCountersinkHoles'
        }, ({ count, ...kickPlateFixingHoles })=>({
                ...kickPlateFixingHoles,
                horizontalCount: count,
                verticalCount: 0
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v4.js.map